/**
 * Server-identical PAP product keys for Stripe GLP-1 plans.
 * Dollar amounts live only on the webhook (server/lib/papCommissionMap.js).
 * Do not send these amounts from the browser as the commission source of truth.
 */
export const PAP_PRODUCT_KEYS = {
  TIRZEPATIDE_1_MONTH: "tirzepatide-1-month",
  TIRZEPATIDE_3_MONTH: "tirzepatide-3-month",
  TIRZEPATIDE_6_MONTH: "tirzepatide-6-month",
  TIRZEPATIDE_12_MONTH: "tirzepatide-12-month",
  SEMAGLUTIDE_1_MONTH: "semaglutide-1-month",
  SEMAGLUTIDE_3_MONTH: "semaglutide-3-month",
  SEMAGLUTIDE_6_MONTH: "semaglutide-6-month",
};
